const stMob = {
  containEsportSelect: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    minWidth: '130px',
    width: 'auto',
    height: 'auto',
    padding: '5px',
    backgroundColor: '#cdfae5',
    borderRadius: '40px',
    border: '1px solid #26b572',
    marginRight: '5px',
  },
  containEsportDefault: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: 'auto',
    minWidth: '130px',
    height: 'auto',
    padding: '5px',
    backgroundColor: '#fff',
    borderRadius: '40px',
    border: '1px solid #f0f0f0',
    marginRight: '5px',
  },
  imgEsport: {
    width: '30px',
    height: '30px',
    borderRadius: '50%',
    marginRight: '5px',
  },
  containTextEsport: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '100%',
  },
  textEsport: {
    color: 'var(--color-text-pri)',
    fontSize: '16px',
    fontWeight: '500',
    textAlign: 'left',
    width: '100%',
  },
  iconSelected: {
    color: '#11c16d',
    minWidth: '22px',
    minHeight: '22px',
    marginLeft: '7px',
  },
  iconUnselected: {
    color: 'gray',
    minWidth: '20px',
    minHeight: '20px',
    marginLeft: '7px',
  },
}

export { stMob }
